<div class="pascals-triangle" [style.min-height.px]="height()" [style.--pt-rows]="triangle().length">
  <!-- Diagonal separator between n-labels and cells -->
  <div class="pascals-triangle__diagonal"></div>

  <!-- Triangle rows -->
  @for (row of triangle(); track $index; let n = $index) {
    <div class="pascals-triangle__row" [style.--pt-offset]="maxRow() - n">
      <!-- n label -->
      <span
        class="pascals-triangle__n-label"
        [class.pascals-triangle__n-label--active]="isNActive(n)"
        [class.pascals-triangle__n-label--dimmed]="isNDimmed(n)"
      >
        n=<span class="pascals-triangle__n-value" [class.pascals-triangle__n-value--highlighted]="isNHighlighted(n)">{{
          n
        }}</span>
      </span>

      <!-- Cells -->
      @for (value of row; track $index; let r = $index) {
        <button
          type="button"
          class="pascals-triangle__cell"
          [class.pascals-triangle__cell--selected]="isSelected(n, r)"
          [class.pascals-triangle__cell--path]="isOnPath(n, r)"
          [class.pascals-triangle__cell--highlight-primary]="highlightGroup(n, r) === 'primary'"
          [class.pascals-triangle__cell--highlight-secondary]="highlightGroup(n, r) === 'secondary'"
          [class.pascals-triangle__cell--highlighted]="isThemeColor(highlightGroup(n, r))"
          [class.pascals-triangle__cell--row-highlighted]="isRowHighlighted(n)"
          [class.pascals-triangle__cell--active]="isCellActive(n, r)"
          [class.pascals-triangle__cell--dimmed]="isCellDimmed(n, r)"
          [class.pascals-triangle__cell--not-selectable]="!selectable()"
          [style.color]="cellColorVar(n, r)"
          [style.background-color]="showParentsCellBg(n, r)"
          [attr.data-highlight-color]="isThemeColor(highlightGroup(n, r)) ? highlightGroup(n, r) : null"
          (mouseenter)="onCellHover(n, r)"
          (mouseleave)="onCellLeave()"
          (click)="onCellClick(n, r)"
        >
          {{ value }}
        </button>
      }

      @if (showParents() && plusSignRow() === n) {
        <div class="pascals-triangle__plus-sign" [style.--pt-plus-col]="plusSignCol()">+</div>
      }
    </div>
  }

  <!-- r labels row -->
  <div class="pascals-triangle__row pascals-triangle__r-row">
    @for (r of rLabels(); track r) {
      <span
        class="pascals-triangle__r-label"
        [class.pascals-triangle__r-label--active]="isRActive(r)"
        [class.pascals-triangle__r-label--highlighted]="isRLabelHighlighted(r)"
        [class.pascals-triangle__r-label--dimmed]="isRDimmed(r)"
      >
        r=<span class="pascals-triangle__r-value">{{ r }}</span>
      </span>
    }
  </div>
</div>
